import React from "react"
import Template from "../../components/Template"
import Translations from "../../../components/Translations"
import img1 from "../../images/indicators/indicators.jpg"

function EMA() {
    const Content = () => {
        return (
            <div className={`flex flex-col gap-5`}>
                <img src={img1} alt='/' className={`border border-gray-700 mt-5 mb-5 w-[20%]`}></img>
                <p className={"text-lg"}><Translations category={"docsEMA"} id={1}/></p>
                <p className={"text-lg"}><Translations category={"docsEMA"} id={2}/></p>
                <p className={"text-lg"}><Translations category={"docsEMA"} id={3}/></p>
                <p className={"text-lg"}><Translations category={"docsEMA"} id={4}/></p>
            </div>
        )
    }
    const config = {
        title: <Translations category={"docs"} id={25}/>,
        previousLink: '/docs/pump-average-volume',
        previousTitle: <Translations category={"docs"} id={24}/>,
        nextLink: '/docs/exponential-moving-average-crossover',
        nextTitle: <Translations category={"docs"} id={26}/>,
        content: Content(),
    }

    return (
        <Template config={config}/>
    )
}

export default EMA